import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Snackbar,
  Typography,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import { Edit } from "@material-ui/icons";
import { useTheme } from "@material-ui/core";
import React, { useState } from "react";
import PartyField from "./PartyField";
import { useSnackbar } from "contexts/SnackbarContext";
import { deAssignProfile } from "./ADRP";
import Assign from "./Assign";
import CreateLoginDetails from "./CreateLoginDetails";
import EditProfile from "./EditProfile";
import { displayEmail, getAdditionalEmails, getProfileCountry, getProfileRegion } from "../utils";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "20px 22px",
    textAlign: "left",
    borderRadius: "4px",
    border: "1px solid #E5E5E5",
    boxShadow: "none",
    overflowWrap: "anywhere",
    wordBreak: "normal",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    transition: "border-color 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      borderColor: "#DCDCDC",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    },
    [theme.breakpoints.down("lg")]: {
      padding: "16px 18px",
    },
  },
  headingblue: {
    fontWeight: 700,
    fontSize: "1rem",
    lineHeight: "1.4rem",
    letterSpacing: "0.01em",
    color: theme.palette.primary.main,
  },
  bluetext: {
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: "1.25rem",
    color: theme.palette.primary.main,
    textDecorationLine: "underline",
    "&:hover": {
      textDecorationLine: "underline",
      opacity: 0.8,
    },
  },
  blackheading: {
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.4rem",
    letterSpacing: "0.2px",
    color: TEXT.strong,
    marginTop: "0.35rem",
    marginBottom: "0.35rem",
  },
  text: {
    fontSize: "0.875rem",
    color: TEXT.secondary,
  },
  // The card is a flex column at height 100%, so these grow to fill whatever
  // space is left and push "+ Create login details" to the bottom edge. They
  // used to be fixed heights (1rem / 9.3rem) chosen to make a populated card
  // and an empty one roughly line up, which only worked at one width.
  space: {
    flexGrow: 1,
    minHeight: "1rem",
  },
  space2: {
    flexGrow: 1,
    minHeight: "1rem",
  },
}));

export default function GRO({
  groData: initialGroData,
  caseId,
  companyId,
  mode,
  index,
  refresh,
  allAssignedPrifiles,
  dispute,
  group,
  profileType,
  isDisputeClosed,
}) {
  const classes = useStyles();
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();

  const groData = initialGroData;

  const profileRegion = getProfileRegion(groData);
  const profileCountry = getProfileCountry(groData);

  const [openmodal, setOpenmodal] = useState(false);

  const handleOpenModal = () => {
    setOpenmodal(true);
  };

  const handleCloseModal = () => {
    setOpenmodal(false);
    refresh();
  };

  const [openmodal2, setOpenmodal2] = useState(false);

  const handleOpenModal2 = () => {
    setOpenmodal2(true);
  };

  const handleCloseModal2 = () => {
    setOpenmodal2(false);
  };
  const handleCloseModalAfterProfileCreated = () => {
    setOpenmodal2(false);
    setOpenSnackBar2(true);
  };

  const [openmodal3, setOpenmodal3] = useState(false);

  const handleOpenModal3 = () => {
    setOpenmodal3(true);
  };

  const handleCloseModal3 = () => {
    setOpenmodal3(false);
    refresh();
  };
  const dispute_edit = true;
  const [openSnackBar2, setOpenSnackBar2] = useState(false);
  const handleCloseSnackBar2 = () => {
    setOpenSnackBar2(false);
  };

  return (
    <Paper className={classes.paper}>
      <Grid container justify="space-between">
        <Grid item>
          <Typography className={classes.headingblue}>
            {profileType == "mediator"
              ? typeof index === "number"
                ? "Mediator " + (index + 1)
                : "Mediator(s)"
              : typeof index === "number"
                ? "Arbitrator " + (index + 1)
                : "Arbitrator(s)"}
          </Typography>
        </Grid>
        <Grid item>
          <Edit
            style={{ cursor: isDisputeClosed ? "not-allowed" : "pointer", opacity: isDisputeClosed ? 0.5 : 1, pointerEvents: isDisputeClosed ? "none" : "auto", color: theme.palette.primary.main }}
            onClick={() => {
              if (groData) handleOpenModal3();
              else showSnackbar("There are no profiles to edit", "info");
            }}
          />
        </Grid>
      </Grid>
      <Box height="0.5rem"></Box>
      <Grid container spacing={2}>
        {/* <Grid item style={{ textAlign: "left" }}>
          <Typography
            className={classes.bluetext}
            style={{ cursor: isDisputeClosed ? "not-allowed" : "pointer", opacity: isDisputeClosed ? 0.5 : 1, pointerEvents: isDisputeClosed ? "none" : "auto" }}
            onClick={handleOpenModal}
          >
            Appoint
          </Typography>
        </Grid> */}
        {groData && (
          <Grid item style={{ textAlign: "left" }}>
            <Typography
              className={classes.bluetext}
              style={{ cursor: isDisputeClosed ? "not-allowed" : "pointer", opacity: isDisputeClosed ? 0.5 : 1, pointerEvents: isDisputeClosed ? "none" : "auto" }}
              onClick={() => {
                deAssignProfile(groData.profile.id, caseId).then(() => {
                  refresh();
                });
              }}
            >
              Remove
            </Typography>
          </Grid>
        )}
      </Grid>
      {typeof index === "number" ? (
        <>
          <Grid container>
            <Grid item style={{ textAlign: "left" }}>
              <Typography className={classes.blackheading}>
                {groData.user.first_name} {groData.user.last_name}
              </Typography>
            </Grid>
          </Grid>
          <PartyField label="Email" value={displayEmail(groData.user.email)} className={classes.text} />
          {getAdditionalEmails(groData).length > 0 && (
            <PartyField label="Additional Emails" value={getAdditionalEmails(groData).join(", ")} className={classes.text} />
          )}
          <PartyField label="Phone" value={groData.profile.phone_number} className={classes.text} />
          <PartyField label="Apartment and Street" value={groData.profile.address} className={classes.text} />
          <PartyField label="City" value={groData.profile.city} className={classes.text} />
          <PartyField label="State" value={profileRegion} className={classes.text} />
          <PartyField label="Postal code" value={groData.profile.postal_code} className={classes.text} />
          <PartyField label="Country" value={profileCountry} className={classes.text} />
          <Box className={classes.space}></Box>
        </>
      ) : (
        <>
          <Box className={classes.space2}></Box>
        </>
      )}
      {/* <Grid container>
        <Grid item style={{ textAlign: "left" }}>
          <Typography
            className={classes.bluetext}
            style={{ cursor: isDisputeClosed ? "not-allowed" : "pointer", opacity: isDisputeClosed ? 0.5 : 1, pointerEvents: isDisputeClosed ? "none" : "auto" }}
            onClick={handleOpenModal2}
          >
            + Create login details
          </Typography>
        </Grid>
      </Grid> */}

      {/* {openmodal && (
        <Assign
          openmodal={openmodal}
          handleCloseModal={handleCloseModal}
          caseId={caseId}
          profileType={
            profileType == "arbitrator_rv"
              ? "arbitrator_rv"
              : "mediator"
          }
          allAssignedPrifiles={allAssignedPrifiles}
          dispute={dispute}
        />
      )}
      {openmodal2 && (
        <CreateLoginDetails
          openmodal={openmodal2}
          handleCloseModal={handleCloseModal2}
          handleCloseModalAfterProfileCreated={
            handleCloseModalAfterProfileCreated
          }
          caseId={caseId}
          profileType={
            profileType == "arbitrator_rv"
              ? "arbitrator_rv"
              : "mediator"
          }
          companyId={companyId}
          dispute={dispute}
          group={group}
        />
      )} */}
      {openmodal3 && (
        <EditProfile
          openmodal={openmodal3}
          handleCloseModal={handleCloseModal3}
          profileData={groData}
          profileType={
            profileType == "arbitrator_rv"
              ? "arbitrator_rv"
              : "mediator"
          }
          partyType="arbitrator"
          dispute_edit={dispute_edit}
          refresh={refresh}
          caseId={caseId}
        />
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar2}
        onClose={handleCloseSnackBar2}
        message="Guest profile is created."
      // key={vertical + horizontal}
      >
        <Alert onClose={handleCloseSnackBar2} severity="success">
          Profile is created.
        </Alert>
      </Snackbar>
    </Paper>
  );
}
